var _script, _rect, _g, _defs, _script2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 22,
    viewBox: "9 8 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(1.6)",
    d: "M16.7033 11.5C17.615 11.5 18.3499 11.5 18.9278 11.5777C19.5279 11.6584 20.0332 11.831 20.4344 12.2322C20.8357 12.6335 21.0083 13.1388 21.089 13.7388C21.1667 14.3168 21.1667 15.0517 21.1667 15.9634V16.7032C21.1667 17.615 21.1667 18.3499 21.089 18.9278C21.0083 19.5279 20.8357 20.0332 20.4344 20.4344C20.0332 20.8357 19.5279 21.0083 18.9278 21.089C18.3499 21.1667 17.615 21.1667 16.7032 21.1667H15.9634C15.0517 21.1667 14.3168 21.1667 13.7388 21.089C13.1388 21.0083 12.6335 20.8357 12.2322 20.4344C11.831 20.0332 11.6584 19.5279 11.5777 18.9278C11.5 18.3499 11.5 17.615 11.5 16.7033V16.7032V15.9634V15.9634C11.5 15.0517 11.5 14.3168 11.5777 13.7388C11.6584 13.1388 11.831 12.6335 12.2322 12.2322C12.6335 11.831 13.1388 11.6584 13.7388 11.5777C14.3168 11.5 15.0517 11.5 15.9634 11.5H15.9634H16.7033H16.7033Z",
    fill: "#846CFF"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(1.6)",
    d: "M10.5 15.9047C10.4999 15.0419 10.4999 14.2506 10.5866 13.6056C10.6821 12.8951 10.9069 12.1434 11.5251 11.5252C12.1433 10.9069 12.895 10.6822 13.6056 10.5866C14.2505 10.4999 15.0418 10.5 15.9046 10.5L17.3954 10.5C17.5927 10.5 17.6914 10.5 17.7507 10.4362C17.8101 10.3723 17.803 10.2762 17.7888 10.0839C17.7765 9.91702 17.7608 9.75932 17.7407 9.61033C17.6545 8.97063 17.4821 8.43904 17.1145 7.99113C16.9829 7.83079 16.8359 7.68376 16.6756 7.55217C16.2029 7.1643 15.6371 6.99374 14.9498 6.91249C14.2803 6.83336 13.4341 6.83337 12.3659 6.83337H12.3007C11.2325 6.83337 10.3863 6.83336 9.71681 6.91249C9.0295 6.99374 8.4637 7.1643 7.99107 7.55217C7.83073 7.68376 7.6837 7.83079 7.55211 7.99113C7.16424 8.46376 6.99368 9.02956 6.91243 9.71687C6.8333 10.3864 6.83331 11.2326 6.83331 12.3008V12.366C6.83331 13.4342 6.8333 14.2804 6.91243 14.9499C6.99368 15.6372 7.16423 16.203 7.55211 16.6756C7.6837 16.836 7.83073 16.983 7.99107 17.1146C8.43898 17.4822 8.97057 17.6546 9.61027 17.7408C9.75926 17.7609 9.91695 17.7766 10.0839 17.7889C10.2761 17.803 10.3722 17.8101 10.4361 17.7508C10.5 17.6914 10.5 17.5928 10.5 17.3955V15.9047Z",
    fill: "#846CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9fd43c0891d0a4397332224ca2fe257b.svg";
export { ForwardRef as ReactComponent };